import React, {Component} from "react";
import {ScaleLoader} from 'react-spinners';

export class Loading extends Component {
    componentDidMount(): void {
        document.body.classList.add('overflow-hidden');
    }

    componentWillUnmount(): void {
        document.body.classList.remove('overflow-hidden');
    }

    render(): JSX.Element {
        return (
            <div className="loading-container">
                <ScaleLoader
                    color={'#fff'}
                />
            </div>
        );
    }
}